import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   redirect: "/home",
  // },
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "about" */ "../views/mainPage.vue"),
  },

  {
    path: "/productCenter",
    name: "ProductCenter",
    component: () => import(/* webpackChunkName: "about" */ "../views/productCenter.vue"),
  },
  {
    path: "/productCenter/detail/:id",
    name: "ProductDetail",
    props: true,
    component: () => import(/* webpackChunkName: "about" */ "../views/productDetail.vue"),
  },
  {
    path: "/solution",
    name: "Solution",
    component: () => import(/* webpackChunkName: "about" */ "../views/solution.vue"),
  },
  {
    path: "/examples",
    name: "Examples",
    component: () => import(/* webpackChunkName: "about" */ "../views/examples.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import(/* webpackChunkName: "about" */ "../views/contact.vue"),
  },
  {
    path: "/service",
    name: "Service",
    component: () => import(/* webpackChunkName: "about" */ "../views/service.vue"),
  },
  {
    path: "/service/detail/:id",
    name: "ServiceDetail",
    props: true,
    component: () => import(/* webpackChunkName: "about" */ "../views/serviceDetail.vue"),
  },
  {
    path: "/display/detail/:id",
    name: "Display",
    props: true,
    component: () => import(/* webpackChunkName: "about" */ "../views/display.vue"),
  },
    {
        path: "/lxwm",
        name: "Lxwm",
        component: () => import(/* webpackChunkName: "about" */ "../views/lxwm.vue"),
    },
    {
        path: "/news/detail/:id",
        name: "NewsDetail",
        props: true,
        component: () => import(/* webpackChunkName: "about" */ "../views/newsDetail.vue"),
    },
];

const router = new VueRouter({
  base:"/dist/",
  mode:'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;
